// temp data
const contact = {
  '1000': {
    userName: 'Charlotte',
    avatar: './static/av1.jpg',
    bio: 'Enjoy the little things in life.',
    sex: 'female',
    remarks: '',
    location: 'New Zealand'
  },
  '1001': {
    userName: 'Ethan',
    avatar: './static/av2.jpg',
    bio: '慢慢来，每天进步一点。',
    sex: 'male',
    remarks: '',
    location: '广东 深圳'
  },
  '1002': {
    userName: 'Oliver',
    avatar: './static/av3.jpg',
    bio: '螃蟹在剥我的壳，笔记本在写我，漫天的我落在雪花上。',
    sex: 'male',
    remarks: '',
    location: 'Amsterdam'
  },
  '1003': {
    userName: 'Lucas',
    avatar: './static/av4.jpg',
    bio: '今天也要好好生活。',
    sex: 'male',
    remarks: '',
    location: ''
  },
  '1004': {
    userName: 'yuxino',
    avatar: './static/yuxino.jpg',
    bio: '你好，很高兴认识你。',
    sex: 'male',
    remarks: '',
    location: '广东 深圳'
  },
  '1005': {
    userName: 'Sophie',
    avatar: './static/av6.jpg',
    bio: '',
    sex: 'female',
    remarks: '',
    location: 'Hokkaido'
  },
  '1006': {
    userName: 'Noah',
    avatar: './static/av7.jpg',
    bio: '慢热 ！',
    sex: 'male',
    remarks: '',
    location: '上海 虹口'
  }
}

export default contact



// WEBPACK FOOTER //
// ./src/store/contact.js